'use client'

import Login from '@/components/auth/login'
import Loading from '@/components/shared/loading'
import useFixCssOverride from '@/hooks/use-fix-css-override'
import { useAppSelector } from '@/redux/utils'

import Layout from './layout'

export default function Main() {
  const { initializing, isLogin } = useAppSelector((state) => state.global)

  useFixCssOverride()

  if (initializing) {
    return <Loading />
  }

  if (isLogin) {
    return <Layout />
  }

  return <Login />
}
